import * as React from 'react';
import { Toast, ToastBody, ToastHeader, Spinner } from 'reactstrap';
import { useAppDispatch, useAppSelector } from '../../hooks';
import { Affiliation, canReportForType, Entity,  getSelectedEntity, createNameChangeEntry } from '../../redux/EntitySlice';
import { EntityReference, getEntityNameForCode, selectEntities } from '../../redux/EntitiesSlice';
import { getTaxonomyType } from '../../redux/MiscSlice';
import { TaxonomyTypeEnum } from '../../redux/TaxonomyVersionSlice';
import { Reference } from '../../redux/TaxonomyReferenceSlice';
import dateHelper from '../../utils/dateHelper';
import utilityHelper from '../../utils/utilityHelper';
import ToastReporter from './ToastReporter'

const EntityReporter = (props: any) => {
    //TODO create a generic reporter component to actually render the topic and details.
    //props should include title and detail list
    const dispatch = useAppDispatch();
    var entity: Entity | null = useAppSelector(getSelectedEntity);
    var tType: TaxonomyTypeEnum | null = useAppSelector(getTaxonomyType);
    var entityList: EntityReference[] = useAppSelector(selectEntities);
    var numContacts = 0;
    var dissolvedDate = "";
    var inactiveDate = "";
    var renamedDate = "";
    var mergedDate = "";
    var reportAccess = "false";
    var statusReason = "";
    if (entity && entity.contacts ) {
        numContacts = entity.contacts.length;
    }
    var detaildata: any = [];
    if (entity) {
        dissolvedDate = entity.dissolvedDate ? dateHelper.stringDateInFormat(entity.dissolvedDate, "LL/dd/yyyy") : "";
        inactiveDate = entity.inactiveDate ? dateHelper.stringDateInFormat(entity.inactiveDate, "LL/dd/yyyy") : "";
        renamedDate = entity.renamedDate ? dateHelper.stringDateInFormat(entity.renamedDate, "LL/dd/yyyy") : "";
        mergedDate = entity.mergedDate ? dateHelper.stringDateInFormat(entity.mergedDate, "LL/dd/yyyy") : "";
        if (canReportForType(entity, tType)) {
            reportAccess = "true";
        }

        detaildata = [
            { key: "Name", value: entity.name },
            { key: "Entity Type", value: entity.typecode ? utilityHelper.toProperCase(entity.typecode.replace("_", " ")) : ""},
            { key: "Entity ID", value: entity.code },
            { key: "Unit Status", value: entity.status ? utilityHelper.toProperCase(entity.status.replace("_", " ")) : ""},
            { key: "Creation Date", value: entity.creationDate ? dateHelper.stringDateInFormat(entity.creationDate, "LL/dd/yyyy") : "" },
            { key: "Dissolved Date", value: dissolvedDate },
            { key: "Inactive Date", value: inactiveDate },
            { key: "Renamed Date", value: renamedDate },
            { key: "Merged Date", value: mergedDate },
            { key: "Contacts", value: numContacts },
            { key: "Can Report", value: reportAccess }
        ];
        if (dissolvedDate.length === 0) {
            detaildata.splice(detaildata.findIndex((x: any) => x.key === "Dissolved Date"), 1);
        }
        if (inactiveDate.length === 0) {
            detaildata.splice(detaildata.findIndex((x: any) => x.key === "Inactive Date"), 1);
        }
        if (renamedDate.length === 0) {
            detaildata.splice(detaildata.findIndex((x: any) => x.key === "Renamed Date"), 1);
        }
        if (mergedDate.length === 0) {
            detaildata.splice(detaildata.findIndex((x: any) => x.key === "Merged Date"), 1);
        }

        if (entity.districttype) {
            switch (entity.typecode) {
                case "CITY":
                case "COUNTY":
                    // don't add
                    break;

                default:
                    detaildata.push({ key: "District Type", value: utilityHelper.toProperCase(entity.districttype) });
                    break;
            }
        }
        if (entity.affiliation) {
            var primaryDetail = "";
            var affEntry: Affiliation | null = entity.affiliation;
            while (affEntry) {
                primaryDetail += utilityHelper.toProperCase(affEntry.affiliate.name);
                if (affEntry.endDate) {
                    primaryDetail += " (" + dateHelper.stringToDateString(affEntry.effectiveDate) + "-" + dateHelper.stringToDateString(affEntry.endDate) + "), ";
                } else {
                    primaryDetail += " (" + dateHelper.stringToDateString(affEntry.effectiveDate) + "), ";
                }
                affEntry = affEntry.prior;
            }
            detaildata.push({ key: "Primary Government", value: primaryDetail });
        }
        if (entity.districtDependency !== "NONE") {
            detaildata.push({ key: "Dependency", value: utilityHelper.toProperCase(entity.districtDependency) });
        }
        if (entity.references) {
            entity.references.map(x => (x.type.indexOf("nameChange") > 0) ? detaildata.push({ key: "Name change", value: createNameChangeEntry(x) } ) : "");
        }
        if (entity.doingBusinessAs) {
            if (entity.doingBusinessAs.previousEntity === entity.code) {
                detaildata.push({ key: "DBA", value: "Currently doing business as " + getEntityNameForCode(entityList,entity.doingBusinessAs.currentEntity) });
            } else {
                detaildata.push({ key: "DBA", value: "Previously doing business as " + getEntityNameForCode(entityList, entity.doingBusinessAs.previousEntity) });
            }
        }

        detaildata.push({ key: "StatusReason", value: entity.status ? utilityHelper.toProperCase(entity.status.replace("_", " ")) : "" + " Reason-" + entity.statusReason });
        
    } else {
        detaildata = [];
    }
    return (
        <div>
            {
                entity != null ?
                    <ToastReporter topic="Current Entity" style="" details={detaildata} showReadMoreMaxChars={0} />
                    : (<div></div>)
            }
        </div>
    )
}

export default EntityReporter;